export const SnackBarAction = {
    SET: 'SET',
    SET_ACTIVE: 'SET_ACTIVE',
};

export const SnackBarMutation = {
    SET: 'SET',
    SET_ACTIVE: 'SET_ACTIVE',
};

export const SnackBarTypes = {
    ERROR: 'error',
    SUCCESS: 'success',
    WARNING: 'warning',
    INFO: 'info',
};